// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EditPenFilledSvg from "@fishx/icons-svg/es/asn/EditPenFilled";
import FishxIcon from '../components/FishxIcon';

var EditPenFilled = function EditPenFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EditPenFilledSvg
  }));
};

EditPenFilled.displayName = 'EditPenFilled';
export default React.forwardRef(EditPenFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EditPenFilled.js
// module id = 2591
// module chunks = 0